import { render, staticRenderFns } from "./question-connected.vue?vue&type=template&id=2023e2e6&scoped=true"
import script from "./question-connected.vue?vue&type=script&lang=js"
export * from "./question-connected.vue?vue&type=script&lang=js"
import style0 from "./question-connected.vue?vue&type=style&index=0&id=2023e2e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2023e2e6",
  null
  
)

export default component.exports